import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-tasks',
  templateUrl: './tasks.component.html'
})
export class TasksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
